module.exports = __webpack_public_path__ + "img/Call.7a14ea08.svg";